import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MasterHelper } from 'src/app/core/utilities';
import { UserProfile } from 'src/app/core/models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { GDPRService } from 'src/app/core/services/rulebook';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RuleTreeDataModel } from 'src/app/core/models/rulebook/rule-tree-data-model';
import { RulebookFilterModel } from 'src/app/core/models/rulebook/rulebook-filters-model';
import { RulebookMasterFilter } from 'src/app/core/models/rulebook/rulebook-master-filter';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { GlobalService } from 'src/app/core/services/global/global.service';

export interface Fruit {
  name: string;
}
@Component({
  selector: 'app-rulebook-filters',
  templateUrl: './rulebook-filters.component.html',
  styleUrls: ['./rulebook-filters.component.scss']
})
export class RulebookFiltersComponent implements OnInit {
  @Output() OnFilter = new EventEmitter<any>();
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  rulebookType: string;
  rulebookName: string;
  rulebookFiltersData: RulebookFilterModel;
  filterPersistenceKey = 'rulebookFilters';
  user: UserProfile;
  //filteredKeywords: Observable<string[]>;
  filteredKeywords: string[]= [];
  searchedGeography: FilterViewModel[] = [];
  searchedCountry: FilterViewModel[] = [];
  searchedRulebook: FilterViewModel[] = [];
  masterFilters: RulebookMasterFilter;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchGeographyCntrl: FormControl = new FormControl();
  searchCountryCntrl: FormControl = new FormControl();
  searchRulebookCntrl: FormControl = new FormControl();
  keyCtrl = new FormControl();

  @ViewChild('geographyInput')
  geographyInput!: ElementRef<HTMLInputElement>;
  @ViewChild('geographyAutocomplete')
  geographyAutocomplete!: MatAutocomplete;

  @ViewChild('rulebookInput')
  rulebookInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rulebookAutocomplete')
  rulebookAutocomplete!: MatAutocomplete;

  @ViewChild('countryInput')
  countryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('countryAutocomplete')
  countryAutocomplete!: MatAutocomplete;

  searchOwnerCntrl: FormControl = new FormControl();
  searchedOwner: string[] = [];
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ownerAutocomplete')
  ownerAutocomplete!: MatAutocomplete;
  obligationFormControl = new FormControl(['angular']);

  // keywords: string[] = [
  //   'Accounting',
  //   'Audit',
  //   'Banking Reform',
  //   'Basel I',
  //   'Basel II',
  //   'Basel III',
  //   'Capital',
  //   'Colleges of supervisors',
  //   'Compensation',
  //   'Consumer Protection and Financial Innovation',
  //   'Financial Innovation',
  //   'Corporate Governance',
  //   'Credit risk',
  //   'Deposit Insurance',
  //   'Financial Benchmarks',
  //   'Financial Conglomerates',
  //   'FinTech',
  //   'Implementation monitoring',
  //   'Interest Rate Risk',
  //   'Internal Models',
  //   'Investment Firms',
  //   'Large Exposures and structural measures',
  //   'Leverage Ratio',
  //   'Liquidity',
  //   'Liquidity Risk',
  //   'Macroprudential',
  //   'Market Infrastructures',
  //   'Market Risk',
  //   'Anti Money Laundering',
  //   'Terrorist financing',
  //   'Operational Risk',
  //   'OTC Derivatives',
  //   'Passporting Supervision of Branches',
  //   'Supervision of Branches',
  //   'Payment Services and Electronic Money',
  //   'Electronic Money',
  //   'Recovery',
  //   'Resolution',
  //   'Crisis Management',
  //   'Renumeration',
  //   'Reporting',
  //   'Risk Analysis and Data',
  //   'Risk Management',
  //   'Securitisation',
  //   'Shadow Banking',
  //   'Stress Testing',
  //   'Supervision',
  //   'Supervisory Reviews',
  //   'Systemically Important Financial Institutions',
  //   'Transparency',
  //   'Disclosure',
  //   'Insurance',
  //   'Information Technology and Cyber Security',
  //   'Pillar 1',
  //   'Pillar 2',
  //   'Pillar 3',
  //   'Governance',
  //   'Climate',
  //   'Compensation',
  //   'Credit Rating Agencies',
  //   'Cyber Security',
  //   'Effects of Reform',
  //   'Benchmarks',
  //   'Impact Assessment',
  //   'Legal Entity Identifer',
  //   'Peer Review',
  //   'Fund Management',
  //   'MiFiD',
  //   'IFRS',
  //   'Post Trading',
  //   'Corporate Information',
  //   'Short Selling',
  //   'Market Abuse',
  //   'Market Integrity',
  //   'Prospectus',
  //   'Warnings',
  //   'Trade Repository',
  //   'Securities Financing Transactions',
  //   'Transparency and Disclosure'
  // ];
  //searchedKeywords = this.keywords;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
 // announcer = inject(LiveAnnouncer);
  constructor(
    private gdprService: GDPRService, private route: ActivatedRoute,
    private sessionService: SessionService, private router: Router,
    private _globalService: GlobalService
    ) {

    this.rulebookFiltersData = new RulebookFilterModel();
    this.masterFilters = new RulebookMasterFilter();
    this.user = new UserProfile();
    // this.filteredKeywords = this.keyCtrl.valueChanges.pipe(
    //   map((key: string | null) =>
    //     key ? this._filter(key) : this.keywords.slice()
    //   )
    // );

    this.rulebookType = this.route.snapshot.params === null ? '' : this.route.snapshot.params.rulebook;
    this.rulebookName = this.route.snapshot.params === null ? '' : this.route.snapshot.params.rulebookName;
    if (!this.rulebookType) {
      this.rulebookType = '';
    }
    if (!this.rulebookName) {
      this.rulebookName = '';
    }
    this.rulebookFiltersData.libraryName = this.rulebookType;
    this.rulebookFiltersData.rulebookName = this.replaceAll(this.rulebookName);
    this.rulebookFiltersData = MasterHelper.parseRulebookFilters(this.rulebookFiltersData) as RulebookFilterModel;
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as RulebookFilterModel;
    if (persistFilter) {
      this.rulebookFiltersData = persistFilter;
    }
  }

  async ngOnInit() {
    this.getMasterFilters();
    this.user = await this._globalService.getLoginUserData();
  }

  replaceAll(str: string): string {
    if (str) {
      const strArr = str.split('_');
      if (strArr.length > 0) {
        strArr.forEach(element => {
          str = str.replace('_', ' ');
        });
      }
    }
    return str;
  }


  initFilters(): void {
    this.rulebookFiltersData.geography = [];
    this.rulebookFiltersData.country = [];
    this.rulebookFiltersData.rulebook = [];
    this.rulebookFiltersData.searchQuery = [];
    this.rulebookFiltersData.rulebookId = [];
    this.rulebookFiltersData.fromDate = this.masterFilters.fromDate?this.masterFilters.fromDate:"";
    this.rulebookFiltersData.toDate = this.masterFilters.toDate?this.masterFilters.toDate:"";
    this.searchedGeography = this.masterFilters.geography;
    this.searchedRulebook = this.masterFilters.rulebookType;
    this.searchedCountry = this.masterFilters.country;
    this.rulebookFiltersData.libraryName = this.rulebookType;
    this.rulebookFiltersData.rulebookName = this.rulebookName;
    //changes for new designs
    this.rulebookFiltersData.owner=[];
    this.searchedOwner=this.masterFilters.owner;
    this.rulebookFiltersData.headers = [];
    this.rulebookFiltersData.ruleText = [];
    this.rulebookFiltersData.relatedProvisions = [];
    this.rulebookFiltersData.spiderLinks = [];
    this.rulebookFiltersData.obligation = [];
    this.rulebookFiltersData.risk = [];
    this.rulebookFiltersData.controls = [];
    this.rulebookFiltersData.summary = [];
    this.rulebookFiltersData.interpretation = [];
    this.rulebookFiltersData.linkedControls = [];
    this.filteredKeywords=this.masterFilters.ruleTopic;

    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.rulebookFiltersData));
    this.OnFilter.emit(this.rulebookFiltersData);
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.gdprService.getRulebookFiltersData(this.rulebookType, this.rulebookName).subscribe((result: RulebookMasterFilter) => {
      if (result) {
        this.masterFilters = result;
        this.rulebookFiltersData.fromDate = this.masterFilters.fromDate?this.masterFilters.fromDate:"";
        this.rulebookFiltersData.toDate = this.masterFilters.toDate?this.masterFilters.toDate:"";
        this.searchedGeography = this.masterFilters.geography;
        this.searchedCountry = this.masterFilters.country;
        this.searchedRulebook = this.masterFilters.rulebookType;
        //changes for new designs
        this.searchedOwner=this.masterFilters.owner;
        this.filteredKeywords=this.masterFilters.ruleTopic;
        //end
        this.isLoadingFilters = false;

        this.searchGeographyCntrl.valueChanges.subscribe((data: any) => {
          this.searchedGeography = data
            ? this.filterGeography(data)
            : this.masterFilters.geography;
        });

        this.searchCountryCntrl.valueChanges.subscribe((data: any) => {
          this.searchedCountry = data
            ? this.filterCountry(data)
            : this.masterFilters.country;
        });

        this.searchRulebookCntrl.valueChanges.subscribe((data: any) => {
          this.searchedRulebook = data
            ? this.filterRulebook(data)
            : this.masterFilters.rulebookType;
        });
        //changes for new designs
        this.searchOwnerCntrl.valueChanges.subscribe((data: any) => {
          this.searchedOwner = data
            ? this.filterOwner(data)
            : this.masterFilters.owner;
        });
        this.keyCtrl.valueChanges.subscribe((data: any) => {
          this.filteredKeywords = data
            ? this.filterKeyWords(data)
            : this.masterFilters.ruleTopic;
        });
        //end
      }
    });
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.keywords.filter(
  //     fruit => fruit.toLowerCase().indexOf(filterValue) === 0
  //   );
  // }

  filterGeography(search: string): any {
    return this.searchedGeography.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addGeography(event: MatChipInputEvent): void {
    if (!this.geographyAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.rulebookFiltersData.geography as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchGeographyCntrl.setValue(null);
    }
  }

  selectedGeographyEvent(event: MatAutocompleteSelectedEvent): void {
    let filterData=this.rulebookFiltersData.geography.filter(x=>x==event.option.viewValue);
    if(filterData.length==0){
      if (this.rulebookFiltersData.geography) {
        this.rulebookFiltersData.geography.push(event.option.viewValue);
      } else {
        this.rulebookFiltersData.geography = [];
        this.rulebookFiltersData.geography.push(event.option.viewValue);
      }
    }
    this.geographyInput.nativeElement.value = '';
    this.searchGeographyCntrl.setValue(null);
    this.searchGeographyCntrl.disable();
    this.searchGeographyCntrl.enable();
  }

  removeGeography(status: string): void {
    const index = (this.rulebookFiltersData.geography as string[]).indexOf(status);
    if (index >= 0) {
      (this.rulebookFiltersData.geography as string[]).splice(index, 1);
    }
  }

  filterCountry(search: string): any {
    return this.searchedCountry.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addCountry(event: MatChipInputEvent): void {
    if (!this.countryAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.rulebookFiltersData.country as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchCountryCntrl.setValue(null);
    }
  }

  removeCountry(status: string): void {
    const index = (this.rulebookFiltersData.country as string[]).indexOf(status);
    if (index >= 0) {
      (this.rulebookFiltersData.country as string[]).splice(index, 1);
    }
  }

  selectedCountryEvent(event: MatAutocompleteSelectedEvent): void {
    let filterData=this.rulebookFiltersData.country.filter(x=>x==event.option.viewValue);
    if(filterData.length==0){
      if (this.rulebookFiltersData.country) {
        this.rulebookFiltersData.country.push(event.option.viewValue);
      } else {
        this.rulebookFiltersData.country = [];
        this.rulebookFiltersData.country.push(event.option.viewValue);
      }
    }
    this.countryInput.nativeElement.value = '';
    this.searchCountryCntrl.setValue(null);
    this.searchCountryCntrl.disable();
    this.searchCountryCntrl.enable();
  }

  filterRulebook(search: string): any {
    return this.searchedRulebook.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addRulebook(event: MatChipInputEvent): void {
    if (!this.rulebookAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.rulebookFiltersData.rulebook as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchRulebookCntrl.setValue(null);
    }
  }

  removeRulebook(status: string): void {
    const index = (this.rulebookFiltersData.rulebook as string[]).indexOf(status);
    if (index >= 0) {
      (this.rulebookFiltersData.rulebook as string[]).splice(index, 1);
    }
  }

  selectedRulebook(event: MatAutocompleteSelectedEvent): void {
    let filterData=this.rulebookFiltersData.rulebook.filter(x=>x==event.option.viewValue);
    if(filterData.length==0){
      if (this.rulebookFiltersData.rulebook) {
        this.rulebookFiltersData.rulebook.push(event.option.viewValue);
      } else {
        this.rulebookFiltersData.rulebook = [];
        this.rulebookFiltersData.rulebook.push(event.option.viewValue);
      }
    }
    this.rulebookInput.nativeElement.value = '';
    this.searchRulebookCntrl.setValue(null);
    this.searchRulebookCntrl.disable();
    this.searchRulebookCntrl.enable();
  }

  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        this.rulebookFiltersData.searchQuery.push(value.trim());
      }
      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.rulebookFiltersData.searchQuery) {
      this.rulebookFiltersData.searchQuery.push(event.option.viewValue);
    } else {
      this.rulebookFiltersData.searchQuery = [];
      this.rulebookFiltersData.searchQuery.push(event.option.viewValue);
    }
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  remove(searchstr: string): void {
    const index = (this.rulebookFiltersData.searchQuery as string[]).indexOf(searchstr);
    if (index >= 0) {
      (this.rulebookFiltersData.searchQuery as string[]).splice(index, 1);
    }
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  TriggerAction(): void {
    this.rulebookFiltersData = MasterHelper.parseRulebookFilters(this.rulebookFiltersData) as RulebookFilterModel;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.rulebookFiltersData));
    this.router.navigate([], {
      queryParams: { text: this.rulebookFiltersData.searchQuery },
      queryParamsHandling: 'merge',
    });
    this.OnFilter.emit(this.rulebookFiltersData);
  }

  showRuleTree(): void {
    this.gdprService.isShowRuleTree = true;
    this.rulebookFiltersData = MasterHelper.parseRulebookFilters(this.rulebookFiltersData) as RulebookFilterModel;
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.rulebookFiltersData));
    this.gdprService.getRuleTreeData(this.rulebookFiltersData).subscribe((result: Array<RuleTreeDataModel>) => {
      this.gdprService.isShowRuleTree = false;
      this.gdprService.ruleTree = 'RuleTree';
      this.router.navigate(['/library/rule-tree']);
    });
  }
  //changes for new designs
  filterOwner(search: string): any {
    return this.searchedOwner.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }
  addOwner(event: MatChipInputEvent): void {
    if (!this.ownerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.rulebookFiltersData.owner as string[]).push(value);
      }
      event.chipInput!.clear();
      this.searchOwnerCntrl.setValue(null);
    }
  }

  selectedOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    let filterData=this.rulebookFiltersData.owner.filter(x=>x==event.option.viewValue);
    if(filterData.length==0){
      if (this.rulebookFiltersData.owner) {
        this.rulebookFiltersData.owner.push(event.option.viewValue);
      } else {
        this.rulebookFiltersData.owner = [];
        this.rulebookFiltersData.owner.push(event.option.viewValue);
      }
    }

    this.ownerInput.nativeElement.value = '';
    this.searchOwnerCntrl.setValue(null);
    this.searchOwnerCntrl.disable();
    this.searchOwnerCntrl.enable();
  }

  removeOwner(status: string): void {
    const index = (this.rulebookFiltersData.owner as string[]).indexOf(status);
    if (index >= 0) {
      (this.rulebookFiltersData.owner as string[]).splice(index, 1);
    }
  }
  filterKeyWords(search: string): any {
    return this.filteredKeywords.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
  }


  addObligation(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our obligation
    let filterRow=this.rulebookFiltersData.obligation.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.obligation.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeObligation(obligation: string): void {
    const index = this.rulebookFiltersData.obligation.indexOf(obligation);
    if (index >= 0) {
      this.rulebookFiltersData.obligation.splice(index, 1);
    }
  }

  editObligation(obligation: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove obligation if it no longer has a name
    if (!value) {
      this.removeObligation(obligation);
      return;
    }
    // Edit existing obligation
    const index = this.rulebookFiltersData.obligation.indexOf(obligation);
    if (index >= 0) {
      this.rulebookFiltersData.obligation[index] = value;
    }
  }
  //header filter methods
  addHeader(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our headers
    let filterRow=this.rulebookFiltersData.headers.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.headers.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeHeader(header: string): void {
    const index = this.rulebookFiltersData.headers.indexOf(header);
    if (index >= 0) {
      this.rulebookFiltersData.headers.splice(index, 1);
    }
  }

  editHeader(header: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove headers if it no longer has a name
    if (!value) {
      this.removeHeader(header);
      return;
    }
    // Edit existing headers
    const index = this.rulebookFiltersData.headers.indexOf(header);
    if (index >= 0) {
      this.rulebookFiltersData.headers[index] = value;
    }
  }
   //end header filter methods

  //ruleText filter methods
  addRuleText(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our ruleText
    let filterRow=this.rulebookFiltersData.ruleText.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.ruleText.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeRuleText(ruleText: string): void {
    const index = this.rulebookFiltersData.ruleText.indexOf(ruleText);
    if (index >= 0) {
      this.rulebookFiltersData.ruleText.splice(index, 1);
    }
  }

  editRuleText(ruleText: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove ruleText if it no longer has a name
    if (!value) {
      this.removeRuleText(ruleText);
      return;
    }
    // Edit existing ruleText
    const index = this.rulebookFiltersData.ruleText.indexOf(ruleText);
    if (index >= 0) {
      this.rulebookFiltersData.ruleText[index] = value;
    }
  }
  //end ruleText filter methods

  //relatedProvisions filter methods
  addRelatedProvisions(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our relatedProvisions
    let filterRow=this.rulebookFiltersData.relatedProvisions.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.relatedProvisions.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeRelatedProvisions(relatedProvisions: string): void {
    const index = this.rulebookFiltersData.relatedProvisions.indexOf(relatedProvisions);
    if (index >= 0) {
      this.rulebookFiltersData.relatedProvisions.splice(index, 1);
    }
  }

  editRelatedProvisions(relatedProvisions: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove relatedProvisions if it no longer has a name
    if (!value) {
      this.removeRelatedProvisions(relatedProvisions);
      return;
    }
    // Edit existing relatedProvisions
    const index = this.rulebookFiltersData.relatedProvisions.indexOf(relatedProvisions);
    if (index >= 0) {
      this.rulebookFiltersData.relatedProvisions[index] = value;
    }
  }
  //end relatedProvisions filter methods

  //spiderLinks filter methods
  addSpiderLinks(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our spiderLinks
    let filterRow=this.rulebookFiltersData.spiderLinks.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.spiderLinks.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeSpiderLinks(spiderLinks: string): void {
    const index = this.rulebookFiltersData.spiderLinks.indexOf(spiderLinks);
    if (index >= 0) {
      this.rulebookFiltersData.spiderLinks.splice(index, 1);
    }
  }

  editSpiderLinks(spiderLinks: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove spiderLinks if it no longer has a name
    if (!value) {
      this.removeSpiderLinks(spiderLinks);
      return;
    }
    // Edit existing spiderLinks
    const index = this.rulebookFiltersData.spiderLinks.indexOf(spiderLinks);
    if (index >= 0) {
      this.rulebookFiltersData.spiderLinks[index] = value;
    }
  }
  //end spiderLinks filter methods

  //risk filter methods
  addRisk(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our risk
    let filterRow=this.rulebookFiltersData.risk.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.risk.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeRisk(risk: string): void {
    const index = this.rulebookFiltersData.risk.indexOf(risk);
    if (index >= 0) {
      this.rulebookFiltersData.risk.splice(index, 1);
    }
  }

  editRisk(risk: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove risk if it no longer has a name
    if (!value) {
      this.removeRisk(risk);
      return;
    }
    // Edit existing risk
    const index = this.rulebookFiltersData.risk.indexOf(risk);
    if (index >= 0) {
      this.rulebookFiltersData.risk[index] = value;
    }
  }
  //end risk filter methods

  //controls filter methods
  addControls(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our controls
    let filterRow=this.rulebookFiltersData.controls.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.controls.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeControls(controls: string): void {
    const index = this.rulebookFiltersData.controls.indexOf(controls);
    if (index >= 0) {
      this.rulebookFiltersData.controls.splice(index, 1);
    }
  }

  editControls(controls: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove controls if it no longer has a name
    if (!value) {
      this.removeControls(controls);
      return;
    }
    // Edit existing controls
    const index = this.rulebookFiltersData.controls.indexOf(controls);
    if (index >= 0) {
      this.rulebookFiltersData.controls[index] = value;
    }
  }
  //end controls filter methods

  //summary filter methods
  addSummary(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our summary
    let filterRow=this.rulebookFiltersData.summary.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.summary.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeSummary(summary: string): void {
    const index = this.rulebookFiltersData.summary.indexOf(summary);
    if (index >= 0) {
      this.rulebookFiltersData.summary.splice(index, 1);
    }
  }

  editSummary(summary: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove summary if it no longer has a name
    if (!value) {
      this.removeSummary(summary);
      return;
    }
    // Edit existing summary
    const index = this.rulebookFiltersData.summary.indexOf(summary);
    if (index >= 0) {
      this.rulebookFiltersData.summary[index] = value;
    }
  }
  //end summary filter methods

  //interpretation filter methods
  addInterpretation(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our interpretation
    let filterRow=this.rulebookFiltersData.interpretation.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.interpretation.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeInterpretation(interpretation: string): void {
    const index = this.rulebookFiltersData.interpretation.indexOf(interpretation);
    if (index >= 0) {
      this.rulebookFiltersData.interpretation.splice(index, 1);
    }
  }

  editInterpretation(interpretation: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove interpretation if it no longer has a name
    if (!value) {
      this.removeInterpretation(interpretation);
      return;
    }
    // Edit existing interpretation
    const index = this.rulebookFiltersData.interpretation.indexOf(interpretation);
    if (index >= 0) {
      this.rulebookFiltersData.interpretation[index] = value;
    }
  }
  //end interpretation filter methods

   //linkedControls filter methods
   addLinkedControls(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our LinkedControls
    let filterRow=this.rulebookFiltersData.linkedControls.filter(x=>x==value);
    if(filterRow.length==0){
      if (value) {
        this.rulebookFiltersData.linkedControls.push(value);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeLinkedControls(linkedControls: string): void {
    const index = this.rulebookFiltersData.linkedControls.indexOf(linkedControls);
    if (index >= 0) {
      this.rulebookFiltersData.linkedControls.splice(index, 1);
    }
  }

  editLinkedControls(linkedControls: string, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove linkedControls if it no longer has a name
    if (!value) {
      this.removeLinkedControls(linkedControls);
      return;
    }
    // Edit existing linkedControls
    const index = this.rulebookFiltersData.linkedControls.indexOf(linkedControls);
    if (index >= 0) {
      this.rulebookFiltersData.linkedControls[index] = value;
    }
  }
  //end linkedControls filter methods

  //Serach with Rulebook Id
  addRegulationId(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.rulebookFiltersData.rulebookId.push(+value.trim());
    }
    event.chipInput!.clear();
  }

  removeRegulationId(type: string): void {
    const index = this.rulebookFiltersData.rulebookId.indexOf(+type);

    if (index >= 0) {
      this.rulebookFiltersData.rulebookId.splice(index, 1);
    }
  }
  //end
}
